/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrderReceiptSettingsResponseFromDiscriminatorValue, serializeOrderReceiptSettingsResponse, serializeUpdateOrderReceiptSettingsRequest, type ErrorResponse, type InternalErrorResponse, type OrderReceiptSettingsResponse, type UpdateOrderReceiptSettingsRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/order-receipt-settings
 */
export interface OrderReceiptSettingsRequestBuilder extends BaseRequestBuilder<OrderReceiptSettingsRequestBuilder> {
    /**
     * Returns the email subject line used for each audience of an order receipt — the customer, the sales rep(s) on the order, and the organization itself — resolved to the platform default wherever this organization has not set its own, plus the placeholders a subject may use.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderReceiptSettingsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderReceiptSettingsResponse | undefined>;
    /**
     * Replaces the email subject templates this organization's order receipts use — one for the customer's copy, one for the sales rep(s), one for the organization's own copy. Send all three; null, empty or a template equal to the platform default returns that audience to the default. Templates may use the placeholders listed by the read endpoint; any other placeholder is rejected with a 400 naming it. Returns the resolved settings.
     * @param body Replaces the order receipt subject templates for an organization. Send all three: null, emptyor a template identical to the platform default returns that audience to the default.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderReceiptSettingsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateOrderReceiptSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderReceiptSettingsResponse | undefined>;
    /**
     * Returns the email subject line used for each audience of an order receipt — the customer, the sales rep(s) on the order, and the organization itself — resolved to the platform default wherever this organization has not set its own, plus the placeholders a subject may use.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Replaces the email subject templates this organization's order receipts use — one for the customer's copy, one for the sales rep(s), one for the organization's own copy. Send all three; null, empty or a template equal to the platform default returns that audience to the default. Templates may use the placeholders listed by the read endpoint; any other placeholder is rejected with a 400 naming it. Returns the resolved settings.
     * @param body Replaces the order receipt subject templates for an organization. Send all three: null, emptyor a template identical to the platform default returns that audience to the default.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateOrderReceiptSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrderReceiptSettingsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/order-receipt-settings";
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderReceiptSettingsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OrderReceiptSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderReceiptSettingsResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: OrderReceiptSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderReceiptSettingsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateOrderReceiptSettingsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
